import React, { useState, useEffect } from 'react';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import 'react-dates/lib/css/_datepicker.css';
import '../../styles/common/datePickerV2.scss';
import moment from 'moment';

const DatepickerV2 = (props) => {
  const { Reset = false, emptyField, fromDate, date, id, name, label, star, value, enableFuture, editableInput, displayFormat, statusChecked, dateChange } = props;
  const [depDate, setDepDate] = useState(emptyField === null ? null : moment(new Date(date)).isValid() ? moment(new Date(date)) : moment(new Date()));
  const [toDate, setToDate] = useState(null);  // State for "To date"
  const [focused, setFocused] = useState(false);
  const [filterToFocused, setFilterToFocused] = useState(false);
  const [labelClass, setLabelClass] = useState('filled');
  const [displayValue, setDisplayValue] = useState('');
  const [errorMessage, setErrorMessage] = useState("");

  const wrapperClass = (editableInput && !statusChecked) ? 'hidden-date-input' : '';

  const applyMask = (value) => {
    let numbers = value.replace(/\D/g, '');
    let formatted = '';
    if (numbers.length > 0) formatted = numbers.substring(0, 2);
    if (numbers.length > 2) formatted += '-' + numbers.substring(2, 4);
    if (numbers.length > 4) formatted += '-' + numbers.substring(4, 8);
    return formatted.substring(0, 10);
  };

  const validateDate = (value) => {
    const parsed = moment(value, "DD-MM-YYYY", true);
    if (parsed.isValid()) {
      setDepDate(parsed);
      dateChange?.(parsed);
      setErrorMessage("");
    } else {
      setErrorMessage("*Enter a valid date");
    }
  };

  const handleMaskedChange = (e) => {
    const masked = applyMask(e.target.value);
    setDisplayValue(masked);

    if (masked.length === 10) validateDate(masked);
    else setErrorMessage("");
    setFocused(false);
  };

  useEffect(() => {
    if (depDate?.isValid()) {
      setDisplayValue(moment(depDate).format('DD-MM-YYYY'));
    } else {
      setDisplayValue('');
    }
  }, [depDate]);

  useEffect(() => {
    if (date && moment(date, 'DD-MM-YYYY', true).isValid()) {
      const mDate = moment(date, 'DD-MM-YYYY', true);
      setDisplayValue(mDate.format('DD-MM-YYYY'));
      setDepDate(mDate);
    }
  }, [date]);

  const checkOutsideRange = (param, future, e) => {
    if (future) {
      return false; // Allow all future dates
    }

    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let eventDate = e._d.setHours(0, 0, 0, 0);

    if (param === 'add_job_dt' || param === 'edit_job_dt' || param === 'filter_from_dt' || param === 'filter_to_dt') {
      return !(eventDate <= today);
    } else {
      if (depDate && depDate._d) {
        const depDateValue = depDate._d;
        return !(depDateValue <= e._d);
      } else {
        return !(eventDate <= today);
      }
    }
  };

  const handleLabel = (e) => {
    if (statusChecked) {
      setLabelClass('filled');
    } else {
      setLabelClass('active');
    }
  };

  const reset = () => {
    setDepDate(emptyField === null ? null : moment(new Date()));
    setToDate(null);
    setDisplayValue('');
    setFocused(false);
    setFilterToFocused(false);
    setLabelClass('filled');
  };

  useEffect(() => {
    if (Reset) {
      reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Reset]);

  useEffect(() => {
    if (focused && !editableInput) {
      const element = document.querySelector('.CalendarDay__selected');
      if (element) {
        setTimeout(() => {
          element.focus();
        }, 100);
      }
    }
  }, [focused, editableInput]);

  const customDatePickerType = ['add_job_dt', 'edit_job_dt', 'filter_from_dt', 'filter_to_dt'];

  const isOutsideToDateRange = (day) => {
    if (!fromDate) return false;
    return moment(day).isBefore(fromDate, 'day') || checkOutsideRange(name, enableFuture, day);
  };

  if (customDatePickerType.includes(name)) {
    const handleFocusChange = editableInput ? () => { } : ({ focused }) => setFocused(focused);

    return (
      <>
        <div className="input--content--datepicker" onClick={(e) => handleLabel(e)}>
          <div className="cal--icon left">
            <FontAwesomeIcon icon={faCalendarDay} size="lg" />
          </div>
          {editableInput && !statusChecked ? (
            <>
              <input
                type="text"
                className="DateInput_input"
                id={id ? id : name}
                value={displayValue}
                onChange={handleMaskedChange}
                onFocus={() => setFocused(true)}
                placeholder="DD-MM-YYYY"
                maxLength={10}
                onBlur={() => {
                  if (displayValue.length === 10) {
                    validateDate(displayValue);
                  } else if (displayValue.length > 0) {
                    setErrorMessage("Enter a valid date");
                  }
                }}
              />
              {errorMessage && <div className="error-text">{errorMessage}</div>}
            </>
          ) : null}

          <div className={wrapperClass}>
            <SingleDatePicker
              id={id ? id : name}
              date={value || depDate}
              onDateChange={(date) => {
                dateChange && dateChange(date);
                setDepDate(date);
                setLabelClass('filled');
                setFocused(false);
              }}
              focused={focused}
              onFocusChange={handleFocusChange}
              hideKeyboardShortcutsPanel={true}
              block={true}
              numberOfMonths={1}
              noBorder={true}
              displayFormat={displayFormat ? displayFormat : "DD-MMM-YYYY"}
              placeholder=""
              disabled={statusChecked ? true : false}
              isOutsideRange={name === 'filter_to_dt' ? isOutsideToDateRange : (event) => checkOutsideRange(name, enableFuture, event)}
              anchorDirection="left"
              firstDayOfWeek={1}
              readOnly={!editableInput}
            />
          </div>
          <div className={`date--label  ${labelClass}`}>
            {label}
            {star ? <span className="star">*</span> : ''}
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="input--content--datepicker" onClick={(e) => handleLabel(e)}>
          <SingleDatePicker
            id={name}
            readOnly={true}
            date={value || toDate}
            onDateChange={(date) => setToDate(date)}
            focused={filterToFocused}
            onFocusChange={({ focused }) => setFilterToFocused(focused)}
            hideKeyboardShortcutsPanel={true}
            block={true}
            numberOfMonths={1}
            noBorder={true}
            displayFormat={displayFormat ? displayFormat : "DD-MMM-YYYY"}
            placeholder=""
            isOutsideRange={name === 'filter_to_dt' ? isOutsideToDateRange : (event) => checkOutsideRange(name, enableFuture, event)}
            anchorDirection="left"
            firstDayOfWeek={1}
          />
          <div className={`date--label  ${labelClass}`}>{label}</div>
          <div className="cal--icon">
            <FontAwesomeIcon icon={faCalendarDay} size="lg" />
          </div>
        </div>
      </>
    );
  }
};

export default DatepickerV2;
